module.exports = __webpack_public_path__ + "img/newjubao.35f976c7.jpg";